export default "__VITE_ASSET__C9RL1Znh__"